import moment from "moment";

function obterBgBadge(prazoEmMinutos, createdAt) {

  if (prazoEmMinutos === 0) return "bg-[#717171]";

  const agora = moment();
  const prazoFinal = moment(createdAt).add(prazoEmMinutos, 'minutes');

  const metadePrazo = moment(prazoFinal).subtract(prazoEmMinutos / 2, 'minutes');

  if (agora.isAfter(prazoFinal)) {
    return "bg-red-500";
  } else if (agora.isAfter(metadePrazo) && agora.isBefore(prazoFinal)) {
    return "bg-amber-500";
  } else {
    return "bg-[#717171]";
  }
}

export default obterBgBadge;
